module.exports = __webpack_public_path__ + "img/EcoGreen.fe1930c8.jpg";